export const SET_COMMUNITY_CURRENT_TAB = '@user/SetCommunityCurrentTab'
export const SET_SPONSOR_CURRENT_TAB = '@user/SetSponsorCurrentTab'
